// extracted by mini-css-extract-plugin
export default {"content":"Doctors_content__C5c45"};